import DollarsignCircle from './DollarsignCircle';

export default DollarsignCircle;
